import { doc, updateDoc } from "firebase/firestore";
import saveFormRecord from "../../Components/CluppForms/saveFormRecord";
import { db } from "../../firebase";
import Swal from "sweetalert2";

const abandonCancelation = async ({ session, state, navigate, uid, abandonmentType = "manual" }) => {
  try {
    const abandonmentScreen = state.currentLanding;
    const path = `IT/forms/cancelation-form/${session.sessionID}`;
    const docRef = doc(db, path);
    const abandonmentTimestamp = Date.now();
    await saveFormRecord(session.sessionID, {
      ...state.prevForm,
      abandonmentTimestamp,
      abandonmentScreen,
      abandonmentType 
    });
    await updateDoc(docRef, {
      abandonmentTimestamp,
      abandonmentScreen,
      abandonmentType
    });

    localStorage.clear();
    if (navigate) {
      navigate(`/formulario/cancelacion/mantener?uid=${uid}`);
    }
  } catch (err) {
    console.log("[abandonCancelation] Error:", err);
    Swal.fire({
      icon: "error",
      showConfirmButton: false,
      text: "Lo sentimos, ocurrio un error inesperado.",
    });
  }
};
export default abandonCancelation;
